// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2zDUl","subheader":"ReorderModal_subheader__1JQIu","listWrap":"ReorderModal_listWrap__2eYht"};